<template>
  <div>
    <div v-for="(image, index) in loadImagesInURL" :key="`gallery-image-${index}`">
      <niceone-image v-show="index === currentIndex360" :src="image.src" class="m-auto img-wrapper" preload
                     style="width: 400px"/>
    </div>
    <div class="relative m-auto">
      <three-sixty-slider v-model="currentIndex360" :max="maxLength" :step="1"/>
    </div>
  </div>
</template>

<script setup>
import ThreeSixtySlider from "@/components/common/ThreeSixtySlider";

const {threeSixtyImages} = defineProps({
  threeSixtyImages: {
    type: Array,
    default: () => [],
  },
});

const currentIndex360 = ref(0);
const loadImagesInURL = ref([]);
const maxLength = computed(() => threeSixtyImages?.length - 1)

onMounted(() => {
  for (let i = 0; i < threeSixtyImages.length; i++) {
    loadImagesInURL.value.push(new Image());
    loadImagesInURL.value[i].src = threeSixtyImages[i];
  }
});
</script>

<style scoped></style>
